<script lang="ts">
	import { trackEvent } from '$lib/segment/client';
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import type { ProductDetails } from '../blocks/cart/productDetails.svelte';

	interface ProductSelectorItemProps {
		product: ProductDetails;
	}

	const { product }: ProductSelectorItemProps = $props();

	function select() {
		if (product.stripe_product) {
			checkoutSession.select(product.stripe_product);
		}
		trackEvent('PDP Product Selected', {
			product_name: product.name,
			price_lookup_key: product.stripe_product?.priceLookupKey
		});
	}

	let selected = $derived(
		checkoutSession.selectedLookupKey === product.stripe_product?.priceLookupKey ||
			checkoutSession.selectedBaseStripeProduct?.priceLookupKey ===
				product.stripe_product?.priceLookupKey
	);
</script>

<div
	class={['group relative rounded-lg', { 'pointer-events-none': selected }]}
	role="button"
	onclick={select}
	onkeydown={(e) => {
		if (!['Enter', ' '].includes(e.key)) return;

		e.preventDefault();
		if (!selected) {
			select();
		}
	}}
	tabindex="0"
	aria-label="Select product"
>
	<div
		class={[
			'transit w-26 select-none rounded-lg outline-1 lg:w-22 lg:group-hover:outline-2 lg:group-hover:outline-offset-2',
			selected
				? 'outline-2 outline-offset-2 outline-brown-1'
				: 'outline-offset-[3px] outline-brown-5'
		]}
		style="outline-style: solid;"
	>
		<div class="relative h-15 overflow-hidden rounded-lg border-[0.5px] border-brown-5 lg:h-13">
			<Image
				class="h-full w-full object-cover"
				src={product.thumbnail_image?.filename}
				alt={product.thumbnail_image?.alt}
				title={product.thumbnail_image?.title}
				width={500}
			/>

			{#if product.thumbnail_badge_label}
				<div
					class="absolute left-1 top-1 flex items-center justify-center rounded-3xl bg-orange-6 px-1.5 py-1 text-[10px]/[100%] font-semibold tracking-[-.2px] text-orange-2"
				>
					<p class="-mb-[1px]">{product.thumbnail_badge_label}</p>
				</div>
			{/if}
		</div>
	</div>
	<div class="mt-2 flex items-center gap-x-3 lg:gap-x-2">
		<p class="text-[14px]/[160%] tracking-[-.14px]">
			{product.name}
		</p>
	</div>
</div>
